/**
 * AdSense site-verification bootstrap.
 *
 * Injects the AdSense loader script + the `google-adsense-account` meta tag into
 * <head> so Google's crawler can verify site ownership on EVERY route (incl.
 * pre-login). This is the SPA-friendly verification path (meta-tag + snippet)
 * recommended for AdSense review.
 *
 * Fully DORMANT until REACT_APP_ADSENSE_CLIENT_ID (a `ca-pub-...` value) is set,
 * so dev/preview and the unconfigured prod build load NOTHING.
 *
 * ── Activation (when AdSense approves you) ──
 *   1. Set REACT_APP_ADSENSE_CLIENT_ID=ca-pub-XXXXXXXXXXXXXXXX in the deploy env
 *      (and rebuild — CRA embeds REACT_APP_* at build time).
 *   2. Update public/ads.txt → `google.com, pub-XXXXXXXXXXXXXXXX, DIRECT, f08c47fec0942fa0`
 *      (strip the `ca-` prefix from the client id for ads.txt).
 *   3. To actually SERVE ad units, also set REACT_APP_WEB_AD_PROVIDER=adsense
 *      + REACT_APP_ADSENSE_SLOT_INTERSTITIAL=<slot id> (see AdSenseSlot.js).
 *
 * The CSP (frontend/public/_headers + vercel.json) already allowlists the AdSense
 * domains. If ad units don't render after approval, AdSense may additionally need
 * `'unsafe-inline'` in script-src — test first with Content-Security-Policy-Report-Only.
 */
const ADSENSE_SRC = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js';

export function initAdSenseVerification() {
  if (typeof document === 'undefined') return;
  const clientId = process.env.REACT_APP_ADSENSE_CLIENT_ID;
  if (!clientId || !clientId.startsWith('ca-pub-')) return;

  // Ownership meta tag (AdSense real-time / meta verification method).
  if (!document.querySelector('meta[name="google-adsense-account"]')) {
    const meta = document.createElement('meta');
    meta.name = 'google-adsense-account';
    meta.content = clientId;
    document.head.appendChild(meta);
  }

  // Loader script (also powers Auto Ads + ad units). Loaded once; uses the same
  // `data-emergent-adsense` marker AdSenseSlot.js checks, so the slot loader
  // never double-adds it.
  if (!document.querySelector('script[data-emergent-adsense]')) {
    const s = document.createElement('script');
    s.async = true;
    s.crossOrigin = 'anonymous';
    s.dataset.emergentAdsense = '1';
    s.src = `${ADSENSE_SRC}?client=${encodeURIComponent(clientId)}`;
    document.head.appendChild(s);
  }
}
